import React from 'react';

import { AnalyticsData } from '../../types';

interface RiskIndicatorsProps {
  analytics: AnalyticsData | null;
}

const RiskIndicators: React.FC<RiskIndicatorsProps> = ({ analytics }) => {
  const low = analytics?.risk_counts.Low ?? 0;
  const medium = analytics?.risk_counts.Medium ?? 0;
  const high = analytics?.risk_counts.High ?? 0;

  return (
    <section className="risk-grid">
      <article className="risk-card risk-low">
        <h3>Low</h3>
        <p>{low}</p>
      </article>
      <article className="risk-card risk-medium">
        <h3>Medium</h3>
        <p>{medium}</p>
      </article>
      <article className="risk-card risk-high">
        <h3>High</h3>
        <p>{high}</p>
      </article>
    </section>
  );
};

export default RiskIndicators;
